import { z } from "zod";

import { JobsScrapeStatus } from "@/enum/scrape-enum";
import { MetaDataSchema } from "@/schemas/meta-data";
import { ERROR_TYPE } from "@/utils";

import { ListStatus } from "@/enum/list.enum";

import { ScrapeLevel } from "@/enum/job.enum";

import { MapBusinessSchema } from "./mapBusiness";

const { REQUIRED } = ERROR_TYPE;

export const MapSchema = z.object({
	id: z.number(),
	name: z.string().min(4, { message: REQUIRED }).trim(),
	query: z.string().min(4, { message: REQUIRED }).trim(),
	country: z.string(),
	city: z.string(),
	subtypes: z.array(z.string()).nullable(),
	mapBusiness: z.array(MapBusinessSchema).optional(),
	status: z.nativeEnum(JobsScrapeStatus),
	// Retained leads in this list attributed to this map (PREC-4994). A SQL aggregate arrives as a
	// string at runtime, so coerce before it can reach arithmetic.
	leadCount: z.coerce.number().optional(),
	mapScrapeType: z.nativeEnum(ScrapeLevel),
	activeStatus: z.nativeEnum(ListStatus),
	repeatDaily: z.boolean(),
});

export const CreateMapSchema = z.object({
	id: z.number().optional(),
	name: z.string().min(2, { message: REQUIRED }).trim(),
	query: z.string().min(2, { message: REQUIRED }).trim(),
	country: z.string(),
	city: z.string(),
	subtypes: z.array(z.string()).optional(),
	mapScrapeType: z.nativeEnum(ScrapeLevel),
	repeatDaily: z.boolean(),
	listId: z.number().optional(),
});

export const ToggleMapSchema = z.object({
	id: z.number(),
	activeStatus: z.nativeEnum(ListStatus),
});

export const MapResponseSchema = z.object({
	data: z.array(MapSchema),
	meta: MetaDataSchema,
});

export type Map = z.infer<typeof MapSchema>;

export type ToggleMap = z.infer<typeof ToggleMapSchema>;

export type CreateMap = z.infer<typeof CreateMapSchema>;

export type MapResponse = z.infer<typeof MapResponseSchema>;
